document.addEventListener("DOMContentLoaded", function () {
    const sellingPlanSelector = document.querySelector("div#selling-plan-selector");
    const variantRadioButtons = document.querySelectorAll("input[name='id']");

    if (!sellingPlanSelector || variantRadioButtons.length === 0) {
        console.warn("🚨 Selling plan selector or variant radio buttons not found.");
        return;
    }

    function updateSellingPlanVisibility(variantId) {
        const noSubscriptionMetafield = window.noSubscriptionVariants?.[variantId];
        console.log(`🔎 Checking variant ${variantId}, no_subscription = ${noSubscriptionMetafield}`);

        if (noSubscriptionMetafield === "1") {
            sellingPlanSelector.classList.add("loop-display-none-by-variant");
            console.log("🙈 Hiding div#selling-plan-selector");
        } else {
            sellingPlanSelector.classList.remove("loop-display-none-by-variant");
            console.log("👀 Showing div#selling-plan-selector");
        }
    }

    function waitForInitialCheckedVariant(attempts = 10) {
        const checkedInput = document.querySelector("input[name='id']:checked");
        if (checkedInput) {
            console.log(`✅ Found initial variant ID: ${checkedInput.value}`);
            updateSellingPlanVisibility(checkedInput.value);
        } else if (attempts > 0) {
            // Try again on next frame
            requestAnimationFrame(() => {
                setTimeout(() => waitForInitialCheckedVariant(attempts - 1), 50);
            });
        } else {
            console.warn("⚠️ Couldn't find checked variant after multiple attempts.");
        }
    }

    function setupListeners() {
        variantRadioButtons.forEach(radio => {
            radio.addEventListener("change", function () {
                updateSellingPlanVisibility(this.value);
            });
        });
    }

    function waitForNoSubscriptionVariants(retries = 20) {
        if (typeof window.noSubscriptionVariants !== 'undefined') {
            setupListeners();
            waitForInitialCheckedVariant();
        } else if (retries > 0) {
            setTimeout(() => waitForNoSubscriptionVariants(retries - 1), 100);
        } else {
            console.error("❌ window.noSubscriptionVariants not defined after waiting.");
        }
    }

    waitForNoSubscriptionVariants();
});
